import { render, staticRenderFns } from "./FinvoiceParserPatterns.vue?vue&type=template&id=0844850b&scoped=true"
import script from "./FinvoiceParserPatterns.vue?vue&type=script&lang=ts"
export * from "./FinvoiceParserPatterns.vue?vue&type=script&lang=ts"
import style0 from "./FinvoiceParserPatterns.vue?vue&type=style&index=0&id=0844850b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844850b",
  null
  
)

export default component.exports